"use client";

import useModalScrollLock from "@/hooks/useModalScrollLock";
import Image from "next/image";
import React, { useState, useEffect } from "react";
import MilesFoundationForm from "../forms/MilesFoundationForm";

const FoundationBanner = () => {
  const [isFormModelOpen, setIsFormModelOpen] = useState<boolean>(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState<boolean>(false);

  // Check if form was previously submitted on component mount
  useEffect(() => {
    const formSubmitted = localStorage.getItem("gccMpactFormSubmitted");
    if (formSubmitted === "true") {
      setIsFormSubmitted(true);
    }
  }, []);

  const handleFormModelOpen = () => {
    setIsFormModelOpen(true);
  };

  const handleFormModelClose = () => {
    setIsFormModelOpen(false);
  };

  const handleFormSubmit = () => {
    setIsFormSubmitted(true);
  };

  useModalScrollLock(isFormModelOpen, {
    restoreScrollPosition: true,
    preventTouchScroll: true,
  });
  return (
    <div className="w-full bg-center relative">
      {/* Background Image */}
      <div
        className="hidden md:block absolute inset-0 top-0"
        style={{ contain: "layout style paint" }}
      >
        <Image
          src="https://ik.imagekit.io/mileseducation/miles_website/miles-foundation/banner_bg_desk.webp"
          alt="CPA Hero Section Background"
          fill
          className="object-cover z-0"
          priority
        />
      </div>

      <div
        className="block md:hidden absolute inset-0 top-0"
        style={{ contain: "layout style paint" }}
      >
        <Image
          src="https://ik.imagekit.io/mileseducation/miles_website/miles-foundation/banner_bg_mob.webp"
          alt="CPA Hero Section Background"
          fill
          className="object-cover z-0"
          priority
        />
      </div>

      {/* Content */}
      <div className="main_container mx-auto relative px-5 md:py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-0 relative">
          {/* Left Image */}
          <div className="md:block hidden">
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/miles-foundation/banner_left_desktop.webp"
              alt="Left banner"
              width={320}
              height={560}
              className="object-cover"
              priority
            />
          </div>
          <div className="md:hidden block">
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/miles-foundation/banner_mob.webp"
              alt="Left banner"
              width={350}
              height={227}
              className="object-cover mt-10 mx-auto"
              priority
            />
          </div>

          {/* Center Content */}
          <div className="flex justify-center items-center md:w-[450px] md:ml-[-20px]">
            <div className="flex flex-col justify-center text-center">
              <h1 className="text-[#39F] leading-tight font-extrabold text-[40px] md:text-[50px]">
                Miles Foundation
              </h1>

              <p className="text-[#39F] leading-tight font-semibold text-[28px] md:text-[44px] md:mb-2 mb-2">
                Youth for
                <br /> Nation Building
              </p>

              <p className="text-sm md:text-lg text-[#000000BF]/70">
                India’s universities are a powerhouse of latent energy. At Miles
                Foundation, we move beyond &quot;volunteering&quot; to deliver
                High-Quality Social Impact Internships. We bridge the gap
                between academia and real-world impact, turning student
                potential into a catalyst for rural development.
              </p>

              <div className="flex justify-center md:mt-10 mt-7 md:mb-0 mb-8">
                <button
                  type="button"
                  onClick={handleFormModelOpen}
                  className="bg-[#2A85FF] rounded-tl-[13.333px] rounded-tr-[13.333px] rounded-br-[13.333px] rounded-bl-[0px] text-white px-8 md:py-[9.5px] py-[9.5px] font-bold w-[300px] text-sm"
                >
                  Join National Conclave
                </button>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="md:block hidden">
            <Image
              src="https://ik.imagekit.io/mileseducation/miles_website/miles-foundation/banner_right_desktop.webp"
              alt="Right banner"
              width={320}
              height={560}
              className="object-cover absolute right-0"
              priority
            />
          </div>
        </div>
      </div>
      {isFormModelOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div
            className="rounded-2xl shadow-lg relative h-[auto] mx-auto border border-white p-4 w-[400px]"
            style={{
              background:
                "linear-gradient(180deg, rgba(255, 255, 255, 0.30) 0%, rgba(51, 153, 255, 0.30) 100%)",
              boxShadow: "0px 0px 14px 0px rgba(4, 84, 175, 0.29)",
              backdropFilter: "blur(28px)",
            }}
          >
            <button
              type="button"
              onClick={handleFormModelClose}
              className="text-white text-xl md:text-2xl absolute right-1 top-0 cursor-pointer"
            >
              ✕
            </button>
            {!isFormSubmitted && (
              <h2 className="text-white md:text-2xl text-center font-semibold pb-2">
                Join the National Conclave on
                <br /> Youth for Nation-Building
              </h2>
            )}
            <div className="mt-3">
              <MilesFoundationForm
                submitButtonName="Register for the Conclave"
                darkBackground
                onFormSubmit={handleFormSubmit}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FoundationBanner;
